module.exports = __webpack_public_path__ + "static/media/icon-finance.0ce9b061.svg";